import { render, staticRenderFns } from "./MatchMakingBanList.vue?vue&type=template&id=7392d081&scoped=true"
import script from "./MatchMakingBanList.vue?vue&type=script&lang=js"
export * from "./MatchMakingBanList.vue?vue&type=script&lang=js"
import style0 from "./MatchMakingBanList.vue?vue&type=style&index=0&id=7392d081&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7392d081",
  null
  
)

export default component.exports